// extracted by mini-css-extract-plugin
module.exports =  {"hiddenInput":"g97N0j"};